const _env = process.env;

export const NODE_ENV = _env.NODE_ENV;

export const BASE_URL = _env.BASE_URL;

export const AUTH = {
  AUTHORITY: _env.VUE_APP_URL_AUTH,
  CLIENT_ID: _env.VUE_APP_CLIENT_ID,
  POST_LOGOUT_REDIRECT_URI: _env.VUE_APP_SILENT_REDIRECT,
  REDIRECT_URI: _env.VUE_APP_REDIRECT_URI,
  RESPONSE_TYPE: _env.VUE_APP_RESPONSE_TYPE,
  SCOPE: _env.VUE_APP_SCOPE,
  SILENT_REDIRECT_URI: _env.VUE_APP_SILENT_REDIRECT,
  ACR_VALUES: _env.VUE_APP_ACR_VALUES,
};

export const API = {
  BASE_URL: _env.VUE_APP_URL_API,
  TIMEOUT: 120000,
};

export const API_MIPE = {
  BASE_URL: _env.VUE_APP_URL_API_MIPE,
  TIMEOUT: 120000,
};

export const ACR_URL_LOGOUT = _env.VUE_APP_ACR_URL_LOGOUT;
export const ACR_VALUES = _env.VUE_APP_ACR_VALUES;
export const CODE_CHALLENGE = _env.VUE_APP_CODE_CHALLENGE;
export const CODE_CHALLENGE_METHOD = _env.VUE_APP_CODE_CHALLENGE_METHOD;
export const DEFAULT_PAGE_SIZE = _env.VUE_APP_DEFAULT_PAGE_SIZE;
export const SESSION_TIMEOUT = _env.VUE_APP_SESSION_TIMEOUT;
export const DASHBOARD_URL = _env.VUE_APP_DASHBOARD_URL;
export const SECURITY_URL = _env.VUE_APP_SECURITY_URL;
export const ACADEMIC_URL = _env.VUE_APP_ACADEMIC_URL;
export const USER_MENU_APP_SESSION_KEY = `user-menu-${_env.VUE_APP_CLIENT_ID}`;

export const LOGGER = {
  STORE: _env.VUE_APP_LOGGER_STORE === 'false' ? false : true,
  AXIOS: _env.VUE_APP_LOGGER_AXIOS === 'false' ? false : true,
};
